import {MODULE_TYPES} from '../../../constants';

const CACHE = new Set();
const SESSION_STORAGE_KEY = 'enabledModules';

export const setEnabledModules = enabledModules => {
	if (Array.isArray(enabledModules)) {
		sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(enabledModules));
		CACHE.clear();
		enabledModules.forEach(featureFlag => {
			CACHE.add(featureFlag.moduleType);
		});
	}
};

export const hasModule = moduleType => {
	if (!MODULE_TYPES[moduleType]) {
		throw Error(`Unknown module of type '${moduleType}'`);
	}

	if (CACHE.size === 0) {
		const enabledModulesJson = sessionStorage.getItem(SESSION_STORAGE_KEY);
		const enabledModules = enabledModulesJson ? JSON.parse(enabledModulesJson) : [];
		setEnabledModules(enabledModules);
	}
	return CACHE.has(moduleType);
};

export const getModuleEndDate = moduleType => {
	if (!MODULE_TYPES[moduleType]) {
		throw Error(`Unknown module of type '${moduleType}'`);
	}
	const enabledModulesJson = sessionStorage.getItem(SESSION_STORAGE_KEY);
	const enabledModules = enabledModulesJson ? JSON.parse(enabledModulesJson) : [];

	if (!Array.isArray(enabledModules)) return null;

	const module = enabledModules.find(enabledModule => enabledModule.moduleType === moduleType);
	if (!module) return null;

	return {endYear: module.endYear, endMonth: module.endMonth, endDay: module.endDay};
};
